<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JJiun4/tc-custom/9781453226605.jpg?1733084691410" alt="This image is the cover for the book Two Women"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Two Women
      </h1>
      <p class="bookDescription body article font2">
        <b>An accountant’s attempt to rectify the books of his father-in-law’s company sends him headlong into war with the New York mafia<br/><br/></b>John Carver is too good an accountant not to see the irregularity in his father-in-law’s files: three companies, all off shore, with balance sheets that don’t match the ones in the official records. Three companies that represent substantial investment by organized crime. When John confronts his father-in-law, George W. Northcote, the old man insists he has control of the situation, and that the firm is about to be extricated from its criminal association. A few days later, George is dead. His father-in-law’s creative accounting draws John into a knock-down, drag-out battle with the heads of the Five Families of the New York mafia. The battle moves quickly off the balance sheets and into the realm of flesh, blood, and death, and soon everyone John loves—including his wife and mistress—find themselves in the mob’s vengeful crosshairs. This ebook features an illustrated biography of Brian Freemantle including rare photos from the author’s personal collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Freemantle
      </h2>
      
      <p class="authorDescription body article">Brian Freemantle (b. 1936) is one of Britain&rsquo;s most acclaimed authors of spy fiction. His novels have sold over ten million copies worldwide. Born in Southampton, Freemantle entered his career as a journalist, and began writing espionage thrillers in the late 1960s. <i>Charlie M</i> (1977) introduced the world to Charlie Muffin and won Freemantle international success. He would go on to publish fourteen titles in the series.&#160;Freemantle has written dozens of other novels, including two about Sebastian Holmes, an illegitimate son of Sherlock Holmes, and the Cowley and Danilov series, about a Russian policeman and an American FBI agent who work together to combat organized crime in the post&ndash;Cold War world. Freemantle lives and works in Winchester, England.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?329166a1